import { render, staticRenderFns } from "./client-unit-address.vue?vue&type=template&id=6ab7c042&scoped=true&lang=pug&"
import script from "./client-unit-address.vue?vue&type=script&lang=ts&"
export * from "./client-unit-address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7c042",
  null
  
)

export default component.exports